import { Checkbox as ChakraCheckbox, CheckboxProps } from '@chakra-ui/react'
import React from 'react'

export const Checkbox = ({
  size = 'md',
  children,
  ...baseProps
}: CheckboxProps) => {
  return (
    <ChakraCheckbox size={size} {...baseProps}>
      {children}
    </ChakraCheckbox>
  )
}
